import { RouterProvider } from "react-router-dom";
import { routes } from "./routes";
import { AuthContextProvider } from "./context/auth-context";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export interface Logs {
  user_login: string;
  app_version: string;
  server_url: string;
  system_version: string;
  phone_model: string;
  error: string;
  alert_level: number;
  user_details: string;
  device_details: string;
  conection_details: string;
  localization_details: string;
  createdAt: Date;
}

const App = () => {
  return (
    <AuthContextProvider>
      <RouterProvider router={routes} />
      <ToastContainer
        style={{
          width: "400px",
          fontWeight: "bold",
        }}
        position="bottom-center"
        autoClose={1550}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </AuthContextProvider>
  );
};

export default App;
